module.exports = __webpack_public_path__ + "img/Linkedin Icon - white.dd2373ac.svg";